import {
  Button,
  DialogFooter,
  DialogHeader,
  DialogScrollableContent,
  DialogTitle,
  Select,
} from "@win-reality/react-ui";
import { useMemo } from "react";

import { getMetricsForGroup, MetricGroup } from "../../constants/metrics";
import { ThemedDialog } from "../ThemedDialog";

type ChangeMetricDialogProps = {
  open: boolean;
  group: MetricGroup;
  currentMetricId?: string;
  onClose: () => void;
  onSelect: (metricId: string) => void;
  onHide: () => void;
};

/**
 * Props-only port of V1 QuickTileChangeModal + TileSelector: swap the
 * metric shown on a tile, or hide the tile.
 */
export const ChangeMetricDialog = ({
  open,
  group,
  currentMetricId,
  onClose,
  onSelect,
  onHide,
}: ChangeMetricDialogProps) => {
  const items = useMemo(
    () =>
      getMetricsForGroup(group).map((metric) => ({
        value: metric.id,
        label: metric.label,
      })),
    [group],
  );

  return (
    <ThemedDialog
      open={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      defaultCancelButton={false}
      size="sm"
    >
      {({ showDivider, setScrollContainer }) => (
        <>
          <DialogScrollableContent setScrollContainer={setScrollContainer}>
            <DialogHeader>
              <DialogTitle>Change Metric</DialogTitle>
            </DialogHeader>

            <label className="mb-1.5 block text-sm font-semibold tracking-wide">
              {group === "pitch" ? "Pitch Metric" : "Hit Metric"}
            </label>
            <Select
              value={currentMetricId}
              onValueChange={onSelect}
              placeholder="Select a metric"
              items={items}
            />
            <Button
              variant="secondary-flat-light"
              size="sm"
              className="mt-4 w-full"
              data-testid="pitch-metrics-change-metric-dialog-hide-button"
              onClick={onHide}
            >
              Hide This Tile
            </Button>
          </DialogScrollableContent>

          <DialogFooter showDivider={showDivider}>
            <div className="flex w-full justify-start">
              <Button
                variant="ghost"
                data-testid="pitch-metrics-change-metric-dialog-cancel-button"
                onClick={onClose}
                className="underline"
              >
                Cancel
              </Button>
            </div>
          </DialogFooter>
        </>
      )}
    </ThemedDialog>
  );
};
